// ─── Node ID Generator ───────────────────────────────────────────────────────
// Starts at 6; initial nodes in the old static demo used IDs 1–5.
let id = 6;
export const getId = () => `${id++}`;
export const setIdCounter = (nextId) => { id = nextId; };

// ─── Graph Serializer ─────────────────────────────────────────────────────────
// Template content fields (emailContent, mjmlContent, smsContent) are intentionally
// excluded — they live in the template API, not in the flow's graph_json. This ensures
// that editing an email template does NOT trigger a flow auto-save.
export const serializeGraph = (nodes, edges) => {
  const cleanNodes = nodes.map(n => ({
    id: n.id,
    type: n.type,
    position: n.position,
    style: n.style,
    // Exclude UI-only state (selected, dragging) and template content fields
    // (emailContent, mjmlContent, smsContent). None of these should trigger auto-save.
    data: (({ emailContent, mjmlContent, smsContent, ...rest }) => rest)(n.data || {}),
  }));
  return JSON.stringify({ nodes: cleanNodes, edges });
};

// ─── Relative Time Formatter ──────────────────────────────────────────────────
export const formatRelativeTime = (date) => {
  const seconds = Math.floor((new Date() - date) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days > 1 ? 's' : ''} ago`;
};

// ─── Default sidebar components ───────────────────────────────────────────────
export const initialAvailableComponents = {
  actions: [],
  timings: [],
};

// ─── Node sizing ──────────────────────────────────────────────────────────────
// Single source of truth for node dimensions. New nodes start at the default
// width (matching the look of the seeded action nodes) and can be resized down
// to the minimums via the in-canvas resize handles.
export const NODE_DEFAULT_WIDTH = 280;
export const NODE_MIN_WIDTH = 220;
export const NODE_MIN_HEIGHT = 90;

// ─── New-node default style ───────────────────────────────────────────────────
// Only sizing lives here — the node components render their own card (border,
// background, radius), so the wrapper just needs a default width. This matches
// the seeded action nodes, which carry no wrapper style.
export const DEFAULT_NODE_STYLE = {
  width: NODE_DEFAULT_WIDTH,
};
